import {createContext} from '@codeurs/front'
import {EventModel} from 'models/EventModel'
import React, {useContext} from 'react'

export const EventContext = createContext<{event: EventModel}>(undefined)

export const EventContextProvider: React.FC<{
	event: EventModel
}> = ({event, children}) => {
	return (
		<EventContext.Provider value={{event}}>{children}</EventContext.Provider>
	)
}

export const useEvent = () => {
	const {event} = useContext(EventContext)
	return event
}
